import React from "react";
import { useTheme } from "../../providers/ThemeProvider";
import { cx } from "@digitalisation/enlixy-comp";

interface WaitingStateProps {
  /** Primary line, e.g. "Listening for energy signals…". */
  title: string;
  /** Optional NATS subject shown in monospace below the title. */
  subject?: string;
  /** Optional secondary line (used instead of `subject`). */
  detail?: string;
  minHeight?: string;
}

/**
 * Shared "waiting for live data" placeholder for every condition-monitoring
 * screen (motor, energy, future). One spinner + message layout so the empty
 * state looks identical everywhere.
 */
const WaitingState: React.FC<WaitingStateProps> = ({
  title,
  subject,
  detail,
  minHeight = "240px",
}) => {
  const { currentTheme } = useTheme();
  const isDark = currentTheme.isDark;
  return (
    <div
      className="flex flex-col items-center justify-center gap-3"
      style={{ minHeight }}
    >
      <div className="w-8 h-8 rounded-full border-4 border-blue-100 dark:border-blue-900 border-t-blue-500 animate-spin" />
      <p className={cx("text-sm", isDark ? "text-gray-400" : "text-gray-500")}>
        {title}
      </p>
      {subject && (
        <p
          className={cx("text-xs", isDark ? "text-gray-600" : "text-gray-400")}
        >
          Subject: <code className="font-mono">{subject}</code>
        </p>
      )}
      {!subject && detail && (
        <p
          className={cx("text-xs", isDark ? "text-gray-600" : "text-gray-400")}
        >
          {detail}
        </p>
      )}
    </div>
  );
};

export default WaitingState;
